export default __webpack_public_path__ + "static/media/LAS0930.34I-41526_-24870_0.e3fe69d4.jpg";